export type ApiErrorDetail = {
  code: string;
  field?: string;
  message: string;
};

export type ApiError = {
  code: string;
  details: readonly ApiErrorDetail[];
  message: string;
  path?: string;
  requestId?: string;
  status: number;
  timestamp?: string;
};

export class ApiClientError extends Error {
  override readonly name = 'ApiClientError';

  constructor(readonly apiError: ApiError) {
    super(apiError.message);
  }
}
